// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"f3e5deda","104":"f5a65b40","220":"d06b8e51","229":"bbb1974d","232":"5e6cb71f","305":"71cb1b26","655":"f6a29912","782":"45d99965","917":"ebcc5c10","992":"1adf6159"}[chunkId] + ".chunk.js";
};